import classNames from "classnames";

import { Button, Text } from "@pentabd/ui";
import { IconChevronUp, IconChevronDown } from "@pentabd/icons";

import { capitalizeFirstLetter } from "@utils/capitalize";

interface OrderGroupType {
  orderGroupData: object[];
  activeState: number | null;
  action: (arg: number) => void;
  query: any;
}

export const OrderGroup = ({
  orderGroupData,
  activeState,
  action,
  query,
}: OrderGroupType) => {
  return (
    <div className="btn-group">
      {orderGroupData.map((item: any, i: number) => {
        return (
          <Button
            key={i}
            fill="outline"
            type="light"
            size="sm"
            className={classNames("py-5", {
              "bg-extra-light": activeState === i,
            })}
            onClick={() => action(i)}
          >
            <Text>{capitalizeFirstLetter(item.label)}</Text>
            {query[item.value] === "DESC" ? (
              <IconChevronDown key={i} size="16" />
            ) : query[item.value] === "ASC" ? (
              <IconChevronUp key={i} size="16" />
            ) : (
              <></>
            )}
          </Button>
        );
      })}
    </div>
  );
};
